(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('#faq-acc .faq-item__btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('#faq-acc .faq-item').forEach(function(el) {
        el.classList.remove('open');
        el.querySelector('.faq-item__btn').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  // Sticky scroll
  var header = document.querySelector('.hn-header');
  if (header) {
    function onScroll() {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── Live cart count ────────────────────────────────────────
  // Liquid already renders the correct count on load — no fetch needed on init.
  // We only update the badge when the cart actually changes (add/remove).
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }
  // Helper: fetch cart and refresh count
  function fetchAndUpdateCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(data) { updateCartCount(data.item_count); })
      .catch(function() {});
  }
  // Dawn theme fires 'cart:updated' with cartData in detail
  document.addEventListener('cart:updated', function(e) {
    var count = e.detail && e.detail.cartData && e.detail.cartData.item_count;
    if (typeof count === 'number') { updateCartCount(count); return; }
    fetchAndUpdateCount();
  });
  // Fallback event some themes dispatch
  document.addEventListener('cart-update', function() { fetchAndUpdateCount(); });
  // Intercept fetch calls to /cart/add and /cart/change and /cart/update
  (function() {
    var origFetch = window.fetch;
    window.fetch = function(url) {
      var result = origFetch.apply(this, arguments);
      if (typeof url === 'string' && (
        url.indexOf('/cart/add') !== -1 ||
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1
      )) {
        result.then(function(resp) {
          if (resp.ok) { fetchAndUpdateCount(); }
        }).catch(function() {});
      }
      return result;
    };
  })();

  // ── Shared helper ──────────────────────────────────────────
  function getHeaderBottom() {
    var hdr = document.querySelector('.hn-header');
    return hdr ? hdr.getBoundingClientRect().bottom : 68;
  }

  // Mega menu — hover, dynamic top
  var megaTrigger = document.querySelector('[data-mega-trigger]');
  var megaMenu    = document.querySelector('.hn-mega');
  var megaTimer;
  function openMega() {
    clearTimeout(megaTimer);
    if (megaMenu) {
      megaMenu.style.top = getHeaderBottom() + 'px';
      megaMenu.classList.add('is-open');
    }
    if (megaTrigger) megaTrigger.closest('.hn-nav__item').classList.add('is-open');
  }
  function closeMega() {
    megaTimer = setTimeout(function() {
      if (megaMenu) megaMenu.classList.remove('is-open');
      if (megaTrigger) megaTrigger.closest('.hn-nav__item').classList.remove('is-open');
    }, 150);
  }
  if (megaTrigger && megaMenu) {
    megaTrigger.addEventListener('mouseenter', openMega);
    megaTrigger.addEventListener('mouseleave', closeMega);
    megaMenu.addEventListener('mouseenter', openMega);
    megaMenu.addEventListener('mouseleave', closeMega);
  }
  // Update mega top on scroll too
  window.addEventListener('scroll', function() {
    var hBottom = getHeaderBottom();
    if (megaMenu && megaMenu.classList.contains('is-open')) {
      megaMenu.style.top = hBottom + 'px';
    }
    // Keep drawer and overlay top in sync with header when scrolling
    if (isDrawerOpen) {
      if (drawer) drawer.style.top = hBottom + 'px';
      if (overlay) overlay.style.top = hBottom + 'px';
    }
  }, { passive: true });

  // Feature card popup — New Drop button (mobile/≤1280px) + desktop hover
  var fcPopup    = document.getElementById('hn-fc-popup');
  var fcClose    = document.getElementById('hn-fc-close');
  var newDropBtn = document.getElementById('hn-newdrop-btn');

  function openPopup() {
    if (!fcPopup) return;
    fcPopup.classList.add('is-open');
  }
  function closePopup() {
    if (!fcPopup) return;
    fcPopup.classList.remove('is-open');
  }

  // New Drop button in drawer — open popup every time
  if (newDropBtn) {
    newDropBtn.addEventListener('click', function() {
      openPopup();
    });
  }
  if (fcClose)  fcClose.addEventListener('click', function(e){ e.preventDefault(); closePopup(); });
  if (fcPopup)  fcPopup.addEventListener('click', function(e){ if (e.target === fcPopup) closePopup(); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closePopup(); });

  // Countdown timer — synced via sessionStorage so same time on btn + popup
  (function(){
    var endKey = 'fc_end';
    var stored = sessionStorage.getItem(endKey);
    var end = stored ? parseInt(stored) : 0;
    if (!end || end < Date.now()) {
      end = Date.now() + (23 * 3600 + 59 * 60 + 59) * 1000;
      sessionStorage.setItem(endKey, end);
    }
    var popH = document.getElementById('hn-popup-h');
    var popM = document.getElementById('hn-popup-m');
    var popS = document.getElementById('hn-popup-s');
    var btnT = document.getElementById('hn-btn-timer');
    var megH = document.getElementById('hn-mega-h');
    var megM = document.getElementById('hn-mega-m');
    var megS = document.getElementById('hn-mega-s');
    function pad(n){ return String(n).padStart(2,'0'); }
    function tick(){
      var diff = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var h = Math.floor(diff / 3600);
      var m = Math.floor((diff % 3600) / 60);
      var s = diff % 60;
      if (popH) popH.textContent = pad(h);
      if (popM) popM.textContent = pad(m);
      if (popS) popS.textContent = pad(s);
      if (btnT) btnT.textContent = pad(h)+':'+pad(m)+':'+pad(s);
      if (megH) megH.textContent = pad(h);
      if (megM) megM.textContent = pad(m);
      if (megS) megS.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  })();

  document.querySelectorAll('[data-dropdown]').forEach(function(item) {
    var t;
    item.addEventListener('mouseenter', function(){ clearTimeout(t); item.classList.add('is-open'); });
    item.addEventListener('mouseleave', function(){ t = setTimeout(function(){ item.classList.remove('is-open'); }, 150); });
  });

  // Animated placeholder
  var phrasesRaw = document.querySelector('.hn-header') ? document.querySelector('.hn-header').getAttribute('data-phrases') : '';
  var phrases = phrasesRaw ? phrasesRaw.split('|').filter(function(p){ return p.trim() !== ''; }) : ['Search products...'];
  function animatePlaceholder(el) {
    if (!el) return;
    var idx = 0;
    el.textContent = phrases[0];
    setInterval(function() {
      el.classList.add('ph-exit');
      setTimeout(function() {
        idx = (idx + 1) % phrases.length;
        el.textContent = phrases[idx];
        el.classList.remove('ph-exit');
        el.classList.add('ph-enter');
        setTimeout(function(){ el.classList.remove('ph-enter'); }, 300);
      }, 300);
    }, 2800);
  }
  animatePlaceholder(document.querySelector('.hn-search-placeholder'));
  animatePlaceholder(document.querySelector('.hn-search-overlay__placeholder'));

  // ── Predictive Search ──────────────────────────────────────
  var searchDebounceTimer;

  function buildResultHTML(products, collections, query) {
    var html = '';
    if (products.length === 0 && collections.length === 0) {
      html = '<p style="padding:16px;color:#888;font-size:1rem;">No results for "' + query + '"</p>';
      return { html: html, title: 'No Results' };
    }
    if (collections.length > 0) {
      html += '<p class="hn-search-dropdown__title" style="margin-top:0;">Collections</p>';
      collections.forEach(function(col) {
        html += '<a class="hn-popular-item" href="' + col.url + '">'
          + '<div class="hn-popular-item__img-placeholder" aria-hidden="true">'
          + '<svg viewBox="0 0 24 24" fill="none" stroke="#1a6fd4" stroke-width="1.5" stroke-linecap="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>'
          + '</div>'
          + '<div class="hn-popular-item__info"><p class="hn-popular-item__name">' + col.title + '</p>'
          + '<p class="hn-popular-item__price" style="color:#888;font-weight:500;">Collection</p></div>'
          + '<svg class="hn-popular-item__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>'
          + '</a>';
      });
    }
    if (products.length > 0) {
      if (collections.length > 0) html += '<p class="hn-search-dropdown__title" style="margin-top:12px;">Products</p>';
      products.forEach(function(prod) {
        var img = prod.featured_image
          ? '<img class="hn-popular-item__img" src="' + prod.featured_image + '" alt="" width="44" height="44" loading="lazy">'
          : '<div class="hn-popular-item__img-placeholder" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="#bbb" stroke-width="1.5" stroke-linecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg></div>';
        var price = '';
        html += '<a class="hn-popular-item" href="' + prod.url + '">'
          + img
          + '<div class="hn-popular-item__info"><p class="hn-popular-item__name">' + prod.title + '</p>' + price + '</div>'
          + '<svg class="hn-popular-item__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>'
          + '</a>';
      });
    }
    return { html: html, title: 'Results for "' + query + '"' };
  }

  function formatMoney(cents) {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active || '£')
      + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function runPredictiveSearch(query, resultsEl, titleEl, defaultEl) {
    clearTimeout(searchDebounceTimer);
    if (!query || query.trim().length < 2) {
      // Show defaults again
      if (defaultEl) defaultEl.style.display = '';
      if (resultsEl) resultsEl.innerHTML = '';
      if (titleEl) titleEl.textContent = 'Popular Searches';
      return;
    }
    if (defaultEl) defaultEl.style.display = 'none';
    if (titleEl) titleEl.textContent = 'Searching...';
    searchDebounceTimer = setTimeout(function() {
      fetch('/search/suggest.json?q=' + encodeURIComponent(query)
        + '&resources[type]=product,collection&resources[limit]=5')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          var collections = (data.resources && data.resources.results && data.resources.results.collections) || [];
          // Normalise image URLs
          products = products.map(function(p) {
            if (p.featured_image && p.featured_image.url) p.featured_image = p.featured_image.url;
            else if (typeof p.featured_image === 'string') p.featured_image = p.featured_image;
            else p.featured_image = null;
            return p;
          });
          var result = buildResultHTML(products, collections, query);
          if (titleEl) titleEl.textContent = result.title;
          if (resultsEl) resultsEl.innerHTML = result.html;
        })
        .catch(function() {
          if (titleEl) titleEl.textContent = 'Popular Searches';
          if (defaultEl) defaultEl.style.display = '';
          if (resultsEl) resultsEl.innerHTML = '';
        });
    }, 280);
  }

  // Desktop search dropdown
  var si  = document.querySelector('.hn-search-input');
  var sd  = document.querySelector('.hn-search-dropdown');
  var sph = document.querySelector('.hn-search-wrap .hn-search-placeholder');
  var sdTitle   = document.getElementById('hn-sd-title');
  var sdResults = document.getElementById('hn-sd-results');

  function showDefaults(resultsEl, titleEl) {
    if (!resultsEl) return;
    // Remove live results, restore defaults
    resultsEl.querySelectorAll('.hn-popular-item:not(.hn-popular-default)').forEach(function(el){ el.remove(); });
    resultsEl.querySelectorAll('.hn-search-dropdown__title:not(#hn-sd-title):not(#hn-mo-title)').forEach(function(el){ el.remove(); });
    resultsEl.querySelectorAll('p[style]').forEach(function(el){ el.remove(); });
    resultsEl.querySelectorAll('.hn-popular-default').forEach(function(el){ el.style.display = ''; });
    if (titleEl) titleEl.textContent = 'Popular Searches';
  }

  if (si && sd) {
    si.addEventListener('focus', function(){ sd.classList.add('is-open'); });
    document.addEventListener('click', function(e){
      if (!si.closest('.hn-search-wrap').contains(e.target)) sd.classList.remove('is-open');
    });
    si.addEventListener('input', function() {
      if (sph) {
        if (si.value.length > 0) { sph.style.opacity='0'; sph.style.visibility='hidden'; }
        else { sph.style.opacity=''; sph.style.visibility=''; }
      }
      if (si.value.trim().length >= 2) {
        sdResults.querySelectorAll('.hn-popular-default').forEach(function(el){ el.style.display='none'; });
        runPredictiveSearch(si.value.trim(), sdResults, sdTitle, null);
      } else {
        showDefaults(sdResults, sdTitle);
      }
    });
  }

  // Mobile search overlay predictive search
  var msi      = document.querySelector('.hn-search-overlay__input');
  var msdList  = document.getElementById('hn-mo-results');
  var msdTitle = document.getElementById('hn-mo-title');

  if (msi && msdList) {
    msi.addEventListener('input', function() {
      var mph = document.querySelector('.hn-search-overlay__placeholder');
      if (mph) {
        if (msi.value.length > 0) { mph.style.opacity='0'; mph.style.visibility='hidden'; }
        else { mph.style.opacity=''; mph.style.visibility=''; }
      }
      if (msi.value.trim().length >= 2) {
        msdList.querySelectorAll('.hn-popular-default').forEach(function(el){ el.style.display='none'; });
        runPredictiveSearch(msi.value.trim(), msdList, msdTitle, null);
      } else {
        showDefaults(msdList, msdTitle);
      }
    });
  }

  // ── Voice / Mic search ─────────────────────────────────────
  function setupMic(btnId, inputEl) {
    var btn = document.getElementById(btnId);
    if (!btn || !inputEl) return;
    var SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) { btn.style.display = 'none'; return; }
    var recog = new SpeechRecognition();
    recog.lang = 'en-US';
    recog.interimResults = false;
    recog.maxAlternatives = 1;
    var listening = false;
    btn.addEventListener('click', function() {
      if (listening) { recog.stop(); return; }
      recog.start();
    });
    recog.onstart = function() {
      listening = true;
      btn.classList.add('is-listening');
      btn.setAttribute('aria-label', 'Listening...');
    };
    recog.onresult = function(e) {
      var transcript = e.results[0][0].transcript;
      inputEl.value = transcript;
      // Trigger input event so predictive search fires
      inputEl.dispatchEvent(new Event('input', { bubbles: true }));
      // Hide placeholder
      var ph = inputEl.parentNode.querySelector('.hn-search-placeholder');
      if (ph) { ph.style.opacity='0'; ph.style.visibility='hidden'; }
    };
    recog.onend = function() {
      listening = false;
      btn.classList.remove('is-listening');
      btn.setAttribute('aria-label', 'Search by voice');
    };
    recog.onerror = function() {
      listening = false;
      btn.classList.remove('is-listening');
      btn.setAttribute('aria-label', 'Search by voice');
    };
  }
  setupMic('hn-mic-desktop', si);
  setupMic('hn-mic-mobile', msi);

  // Mobile drawer — toggle on hamburger, close on overlay tap
  var overlay      = document.querySelector('.hn-drawer-overlay');
  var drawer       = document.querySelector('.hn-drawer');
  var drawerToggle = document.querySelector('[data-drawer-toggle]');
  var drawerClose  = document.querySelector('[data-drawer-close]');
  var isDrawerOpen = false;

  function openDrawer() {
    var hdrBottom = getHeaderBottom();
    if (overlay) {
      overlay.style.top = hdrBottom + 'px';
      overlay.style.display = 'block';
      setTimeout(function() { overlay.classList.add('is-open'); }, 10);
    }
    if (drawer) {
      drawer.style.top = hdrBottom + 'px';
      drawer.classList.add('is-open');
    }
    if (drawerToggle) drawerToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    isDrawerOpen = true;
  }

  function closeDrawer() {
    if (overlay) overlay.classList.remove('is-open');
    if (drawer)  drawer.classList.remove('is-open');
    if (drawerToggle) drawerToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    isDrawerOpen = false;
    setTimeout(function() {
      if (overlay && !overlay.classList.contains('is-open')) overlay.style.display = 'none';
    }, 350);
  }

  // Hamburger — tap once to open, tap again to close
  if (drawerToggle) {
    drawerToggle.addEventListener('click', function() {
      isDrawerOpen ? closeDrawer() : openDrawer();
    });
  }
  // X button inside drawer (if present)
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  // Tap the dark overlay (blank space) to close
  if (overlay) overlay.addEventListener('click', closeDrawer);

  // Swipe left to close drawer
  var swipeStartX = 0;
  var swipeStartY = 0;
  if (drawer) {
    drawer.addEventListener('touchstart', function(e) {
      swipeStartX = e.touches[0].clientX;
      swipeStartY = e.touches[0].clientY;
    }, { passive: true });
    drawer.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - swipeStartX;
      var dy = e.changedTouches[0].clientY - swipeStartY;
      // Swipe left: horizontal > 60px, more horizontal than vertical
      if (dx < -60 && Math.abs(dx) > Math.abs(dy)) closeDrawer();
    }, { passive: true });
  }

  // Accordion
  document.querySelectorAll('[data-accordion]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item   = btn.closest('.hn-drawer__nav-item');
      var isOpen = item.classList.contains('is-open');
      document.querySelectorAll('.hn-drawer__nav-item').forEach(function(i){ i.classList.remove('is-open'); });
      if (!isOpen) item.classList.add('is-open');
    });
  });

  // Sub-group + toggle (inside Categories)
  document.querySelectorAll('[data-subgroup]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var group  = btn.closest('.hn-drawer__subgroup');
      var isOpen = group.classList.contains('is-open');
      // Close all other subgroups
      document.querySelectorAll('.hn-drawer__subgroup').forEach(function(g) { g.classList.remove('is-open'); });
      if (!isOpen) group.classList.add('is-open');
    });
  });

  // Mobile search overlay — positioned dynamically below the header
  var searchOverlay     = document.querySelector('.hn-search-overlay');
  var mobileSearchOpen  = document.querySelector('[data-search-open]');
  var mobileSearchClose = document.querySelector('[data-search-close]');
  if (mobileSearchOpen) {
    mobileSearchOpen.addEventListener('click', function() {
      if (searchOverlay) {
        searchOverlay.style.top = getHeaderBottom() + 'px';
        searchOverlay.style.display = 'block';
        setTimeout(function() {
          searchOverlay.classList.add('is-open');
          var inp = searchOverlay.querySelector('.hn-search-overlay__input');
          if (inp) inp.focus();
        }, 20);
      }
    });
  }
  if (mobileSearchClose) {
    mobileSearchClose.addEventListener('click', function() {
      if (searchOverlay) {
        searchOverlay.classList.remove('is-open');
        // Reset input and placeholder
        var inp = searchOverlay.querySelector('.hn-search-overlay__input');
        var ph  = searchOverlay.querySelector('.hn-search-overlay__placeholder');
        if (inp) inp.value = '';
        if (ph)  { ph.style.opacity = ''; ph.style.visibility = ''; }
        setTimeout(function() { searchOverlay.style.display = 'none'; }, 280);
      }
    });
  }

})();

// Global function for mobile bottom nav Categories button
function mbnOpenDrawer(btn, sid) {
  var toggle = document.querySelector('[data-drawer-toggle]');
  if (toggle) toggle.click();
}

  } catch(e) { console.error(e); }
})();
})();
